import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'fl-maintenance-part133',
  templateUrl: './maintenance-part133.component.html',
  styleUrls: ['./maintenance-part133.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaintenanceHookHoistComponent implements OnInit {
  @Input() public maintenanceSummary: FormGroup;

  get hook() {
    return this.maintenanceSummary.get('hook') as FormControl;
  }
  get hoist() {
    return this.maintenanceSummary.get('hoist') as FormControl;
  }

  constructor() {}

  public ngOnInit() {}
}
